@use '@design/design-tokens/typography/typography' as *;

.root {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  width: 100%;
}

.titleDescriptionWrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.titleText {
  @include typography-v2-title-base;
}

.descriptionText {
  @include typography-v2-body-xs;
  color: var(--text-soft);
}
